var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_23_590)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#01AB6C",
    fillOpacity: 0.39
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3134 14.0398C22.247 13.9079 22.1453 13.797 22.0196 13.7193C21.8939 13.6416 21.7492 13.6003 21.6014 13.5998H17.6015V8.79984C17.61 8.62439 17.5606 8.45099 17.4609 8.3064C17.3611 8.16182 17.2165 8.05409 17.0495 7.99984C16.8888 7.947 16.7156 7.9464 16.5546 7.99815C16.3936 8.04989 16.2532 8.15131 16.1535 8.28784L9.75345 17.0878C9.67326 17.2037 9.62511 17.3388 9.61388 17.4792C9.60264 17.6197 9.62871 17.7607 9.68945 17.8878C9.74539 18.0332 9.84256 18.1591 9.96904 18.2501C10.0955 18.3411 10.2458 18.3931 10.4015 18.3998H14.4015V23.1998C14.4016 23.3685 14.455 23.5329 14.5542 23.6694C14.6533 23.8059 14.7931 23.9075 14.9535 23.9598C15.0338 23.9848 15.1173 23.9982 15.2015 23.9998C15.3277 24.0002 15.4522 23.9706 15.5648 23.9136C15.6774 23.8566 15.775 23.7738 15.8495 23.6718L22.2494 14.8718C22.3356 14.7525 22.3872 14.6116 22.3985 14.4648C22.4098 14.3181 22.3804 14.171 22.3134 14.0398ZM16.0015 20.7358V17.5998C16.0015 17.3877 15.9172 17.1842 15.7671 17.0342C15.6171 16.8841 15.4136 16.7998 15.2015 16.7998H12.0015L16.0015 11.2638V14.3998C16.0015 14.612 16.0857 14.8155 16.2358 14.9655C16.3858 15.1156 16.5893 15.1998 16.8015 15.1998H20.0015L16.0015 20.7358Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_23_590",
    x: -9,
    y: -9,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_23_590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_23_590",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/imgIcon.0e3cf45ef38153b3120bf879d917aa7e.svg";
export { ForwardRef as ReactComponent };